var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddusers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59995 12.8C7.17355 12.8 5.19995 10.8264 5.19995 8.4C5.19995 5.9736 7.17355 4 9.59995 4C12.0264 4 14 5.9736 14 8.4C14 10.8264 12.0264 12.8 9.59995 12.8ZM9.59995 4.8C7.61515 4.8 5.99995 6.4152 5.99995 8.4C5.99995 10.3848 7.61515 12 9.59995 12C11.5848 12 13.2 10.3848 13.2 8.4C13.2 6.4152 11.5848 4.8 9.59995 4.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.0016H3.2C2.5384 20.0016 2 19.4632 2 18.8016C2 18.7472 2.0112 17.4536 2.98 16.1616C3.544 15.4096 4.316 14.812 5.2752 14.3864C6.4464 13.8656 7.9016 13.6016 9.6 13.6016C11.2984 13.6016 12.7536 13.8656 13.9248 14.3864C14.884 14.8128 15.656 15.4096 16.22 16.1616C17.1888 17.4536 17.2 18.7472 17.2 18.8016C17.2 19.4632 16.6616 20.0016 16 20.0016Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4.5H20.5V1.5C20.5 1.25238 19.7476 1 19.5 1C19.2524 1 18.5 1.25238 18.5 1.5V4.5H15.5C15.2524 4.5 15 5.25239 15 5.50001C15 5.74763 15.2524 6.5 15.5 6.5H18.5V9.55164C18.5 9.79926 19.2524 10 19.5 10C19.7476 10 20.5 9.79926 20.5 9.55164V6.5H23.5C23.7476 6.5 24 5.74763 24 5.50001C24 5.25239 23.7476 4.5 23.5 4.5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddusers);
export default __webpack_public_path__ + "static/media/add users.468168e37392dd0b5c5df47a20aac0c4.svg";
export { ForwardRef as ReactComponent };